export const TOUCHPOINT_OPTIONS = [
  { value: 'securelink', label: 'SecureLink Check-In' },
  { value: 'pre-visit', label: 'Pre-Visit Intake' },
  { value: 'post-discharge', label: 'Post-Discharge Follow-Up' },
  { value: 'medication-review', label: 'Medication Review' },
  { value: 'symptom-followup', label: 'Symptom Follow-Up' },
  { value: 'targeted', label: 'Targeted Conversation (remote patient delivery)' },
];

export const SPECIALTY_OPTIONS = [
  { value: 'general', label: 'General / Family Medicine' },
  { value: 'cardiology', label: 'Cardiology' },
  { value: 'dermatology', label: 'Dermatology' },
  { value: 'internal-medicine', label: 'Internal Medicine' },
  { value: 'obstetrics', label: 'Obstetrics & Gynecology' },
  { value: 'pediatrics', label: 'Pediatrics' },
  { value: 'orthopedics', label: 'Orthopedics' },
  { value: 'psychiatry', label: 'Psychiatry & Mental Health' },
  { value: 'surgery', label: 'Surgery' },
  { value: 'emergency', label: 'Emergency Medicine' },
];

export const MAX_QUESTIONS_DEFAULT = 20;
export const MAX_QUESTIONS_LIMIT = 60;
export const GOALS_MAX_CHARS = 4000;

export const END_ACTION_OPTIONS = [
  {
    value: 'save_to_cmr',
    label: "Save a summary to the patient's health record",
    helperText:
      "The conversation findings will be stored in the patient's chart for the clinician to review.",
  },
  {
    value: 'notify_provider',
    label: 'Notify me when the patient finishes',
    helperText: 'You will receive an alert when this conversation is completed.',
  },
  {
    value: 'show_facility_map',
    label: 'Show the patient a map of nearby facilities',
    helperText:
      'After finishing, the patient will see a map of clinics and hospitals relevant to their situation.',
  },
  {
    value: 'route_to_checkin',
    label: 'Take the patient to check-in',
    helperText: 'After finishing, the patient will be guided to check in at your clinic.',
  },
];
